import { render, staticRenderFns } from "./Step4ProductsDialog.vue?vue&type=template&id=f9d0ec54&scoped=true"
import script from "./Step4ProductsDialog.vue?vue&type=script&lang=js"
export * from "./Step4ProductsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d0ec54",
  null
  
)

export default component.exports